import axios from "axios";

export const sendToGHL = async (jsonData, accountId, webhookId) => {
    // Safety Check: Prevent sending if IDs are missing (Common cause of failure)
    if (!accountId || !webhookId) {
        throw new Error(`Missing Configuration: AccountID (${accountId}) or WebhookID (${webhookId}) is invalid.`);
    }

    try {
        const response = await axios.post(
            `https://services.leadconnectorhq.com/hooks/${accountId}/webhook-trigger/${webhookId}`,
            jsonData,
            {
                headers: { 'Content-Type': 'application/json' },
                timeout: 30000
            }
        );

        if (response && response.data) {
            return response.data;
        } else {
            throw new Error('GHL Accepted request but returned no data.');
        }

    } catch (error) {
        console.error('GHL Submission Error:', error);
        // Throwing the error allows the UI to show the "Error" toast
        throw error; 
    }
};